import { Box, ColorOptions, Image, ModBox, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { capitalizeTxnDetailsKeys, Colors } from '../../util/util'
import { TextLayout } from './TextLayout'

interface DetailsProps {
  data: any
}

export const DetailsLayout: FC<DetailsProps> = ({ data }: DetailsProps) => {
  const isBbps = data?.product?.isBbps === 'Y'
  const authendicator = data?.product?.attribute?.authenticatorList

  const getKeyValueData = () => {
    const keys = ['biller', 'utrNumber', 'transactionId', 'paidBy']
    let valueData: any = {
      biller: data?.product?.name,
      utrNumber: data?.fulfilment?.productRefNumber ?? 'NA',
      transactionId: data?.id,
      paidBy: data?.payment?.paymentInstrument ?? 'NA',
    }
    if (isBbps) {
      const bbpsTxnId = data?.product?.bbpsRegNo
      keys?.splice(-1, 0, 'bbpsTxnId')
      valueData = { bbpsTxnId: bbpsTxnId, ...valueData }
    }

    if (authendicator?.length) {
      keys?.splice(0, 0, 'consumerDetails')
      valueData = { consumerDetails: authendicator[0], ...valueData }
    }

    const finalData: Array<any> = []
    keys?.map((key) => {
      const retData = {
        key: capitalizeTxnDetailsKeys[key],
        value: valueData[key],
      }
      finalData.push(retData)
    })
    return finalData
  }

  const mapData = getKeyValueData()
  // console.log('mapData', mapData)

  return (
    <Box key={data?.id}>
      <Box flexDirection={'row'} justifyContent={'space-between'}>
        <Text
          fontFamily={'JioType-Bold'}
          fontSize={16}
          lineHeight={24}
          //fontWeight={'700'}
          letterSpacing={-0.09}
          color={Colors.BLACK_14 as ColorOptions}>
          Transaction Details
        </Text>
        <ModBox show={isBbps}>
          <Image source={'bbps'} resizeMode="contain" width={24} height={24} />
        </ModBox>
      </Box>
      <Spacer size={16} direction="vertical" />
      <TextLayout mapData={mapData} />
    </Box>
  )
}
